<template>
   <div id="layoutDefault">
            <div id="layoutDefault_content">
                <main>
                    <MainNav />
                    <header class="page-header page-header-dark bg-gradient-primary-to-secondary">
                        <div class="page-header-content">
                            <div class="container text-center">
                                <div class="row justify-content-center">
                                    <div class="col-lg-8">
                                        <h1 class="page-header-title mb-3">Support</h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="svg-border-rounded text-light">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 144.54 17.34" preserveAspectRatio="none" fill="currentColor"><path d="M144.54,17.34H0V0H144.54ZM0,0S32.36,17.34,72.27,17.34,144.54,0,144.54,0" /></svg>
                        </div>
                    </header>
                    <section class="bg-light py-10">
                        <div class="container">
                            <div class="row justify-content-center">
                                <div class="col-lg-10 col-xl-8">
                                    <div class="single-post">
                                        <p class="lead">We know that when patients and parents are involved in managing their care, kids with IBD start feeling better quickly and are able to get 
                                            back to doing the things that they enjoy. Join our Patient Advisory Council or Parent Working Group to connect with supportive people who live with 
                                            IBD and build tools and resources to better manage IBD care.</p>
                                        <p>The <strong>Patient Advisory Council (PAC)</strong> is a group of young (14 years and up), passionate and motivated patients with IBD. Together, the PAC is a voice 
                                            for all patients in ImproveCareNow. They contribute to research studies and the development of health care innovations; they share valuable experiences 
                                            with healthcare professionals, researchers and others; and they raise awareness of IBD and ImproveCareNow via social media 
                                            like <a href="https://www.improvecarenow.org/tags/pac/" target="_blank">LOOP</a>, <a href="https://twitter.com/ICNPatients" target="_blank">Twitter</a>, and <a href="https://www.instagram.com/icnpatients/" target="_blank">Instagram</a>.</p>
                                        <p class="text-center"><a href="https://www.improvecarenow.org/patients_signup" target="_blank">Join the PAC and Make a Difference!</a></p>
                                        <p>As parents and guardians of children with Crohn’s disease and ulcerative colitis, the <strong>Parent Working Group (PWG)</strong> is committed to enhancing the quality 
                                            of life for the young people and their families who live with IBD. In partnership with the ImproveCareNow Network and the local Care Center teams, 
                                            the PWG empowers patients and their families to thrive in their lives by improving the quality and outcomes of IBD care.</p> 
                                        <p class="text-center"><a href="https://www.improvecarenow.org/parent_working_group_signup" target="_blank">Join the PWG and Make a Difference!</a></p>
                                        <p class="small text-center">Have additional questions? ImproveCareNow would love to hear from you. <a href="https://www.improvecarenow.org/contact-us" target="_blank">Contact Us!</a></p>
                                    </div>  
                                </div>
                            </div>
                        </div>
                        <div class="svg-border-rounded text-dark">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 144.54 17.34" preserveAspectRatio="none" fill="currentColor"><path d="M144.54,17.34H0V0H144.54ZM0,0S32.36,17.34,72.27,17.34,144.54,0,144.54,0" /></svg>
                        </div>
                    </section>
                </main>
            </div>
            <div id="layoutDefault_footer">
                <MainFooter />
            </div>
        </div>
</template>

<script>
import $ from 'jquery';
import MainNav from '@/components/nav.vue'
import MainFooter from '@/components/footer.vue'

export default {
  name: 'Home',
  components: {
    MainNav,
    MainFooter
  }
}
// Collapse Navbar
// Add styling fallback for when a transparent background .navbar-marketing is scrolled
var navbarCollapse = function() {
    if($(".navbar-marketing.bg-transparent.fixed-top").length === 0) {
        return;
    }
    if ($(".navbar-marketing.bg-transparent.fixed-top").offset().top > 0) {
        $(".navbar-marketing").addClass("navbar-scrolled");
    } else {
        $(".navbar-marketing").removeClass("navbar-scrolled");
    }
};
// Collapse now if page is not at top
navbarCollapse();
// Collapse the navbar when page is scrolled
$(window).scroll(navbarCollapse);



</script>
